import { render, staticRenderFns } from "./ViewPartnerProfitOrderPackage.vue?vue&type=template&id=80088b68&scoped=true&"
import script from "./ViewPartnerProfitOrderPackage.vue?vue&type=script&lang=js&"
export * from "./ViewPartnerProfitOrderPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80088b68",
  null
  
)

export default component.exports